$(document).ready(function() {
	
	// intersection observer
	const watcher = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('js-raffle-watcher-active');
				observer.unobserve(entry.target);
			}
		});
	};
	
	const options = {
		root: null,
		rootMargin: '-128px 0px 0px 0px',
		threshold: 0
	};
	
	const observer = new IntersectionObserver(watcher, options);
	
	const targets = document.querySelectorAll('.js-raffle-watcher, .chirp-block-facilities-cards-group');
	targets.forEach(target => observer.observe(target));	
	
	// block :: statistics functionality
	$('.raffle-statistic').each(function(index, statistic) {
		var target = $('.raffle-statistic-number', statistic)[0];
		var end_number = $(target).attr('data-number');
		var prefix = $(target).attr('data-prefix');
		var suffix = $(target).attr('data-suffix');
		var options = {
			decimalPlaces: 0,
			duration: 3,
			enableScrollSpy: true,
			prefix: prefix,
			scrollSpyOnce: true,
			separator: '',
			startVal: 0,
			suffix: suffix,
			useGrouping: true,
			useEasing: false
		};
		var counter = new CountUp(target, end_number, options);
	});
	
});